import React from 'react';
import { showToast } from '../../utils/toast';

export const copySurveyLink = async (surveyId) => {
  const url = new URL(`/surveys/${encodeURIComponent(surveyId)}`, window.location.origin);
  await navigator.clipboard.writeText(url.href);
};

export default function SurveyLinkButton({ survey, className = '' }) {
  if (survey.state === 'draft') return null;

  const copyLink = async () => {
    try {
      await copySurveyLink(survey.id);
      showToast('success', 'Survey link copied.');
    } catch (error) {
      showToast('error', 'Unable to copy the survey link. Check clipboard access in your browser.');
    }
  };

  return (
    <button
      type="button"
      className={`bdc-btn ${className}`.trim()}
      onClick={copyLink}
      disabled={survey.state !== 'open'}
      title={survey.state === 'open' ? 'Copy survey link' : 'Reopen the survey to share it'}
    >
      <i className="bi bi-link-45deg" aria-hidden="true" />
      Copy link
    </button>
  );
}